export const isLogin = function () {
    const token = localStorage.getItem('token');
    return !!token;
};

